module.exports = __webpack_public_path__ + "media/Video 20.4750bb59.mp4";